import { metric } from '../api';
import { L, config } from '../state';
import { escapeHtml, localDateISO, need, show } from '../ui/modal';

const AIRPORT_HINT =
  /airport|aeropuerto|alc\b|flughafen|aéroport|aeroporto|lotnisko|аэропорт|аеропорт|luchthaven|aeroport|letiště|repülőtér/i;

export function booking(): void {
  void metric('booking_open');
  const lang = L();
  const form = lang.form;
  const today = localDateISO();
  const maxPassengers = Math.max(1, Number(config.maxPassengers) || 6);

  show(lang.bookTitle, `
    <form id="bf" class="fields">
      <input name="name" placeholder="${escapeHtml(form.name)}" aria-label="${escapeHtml(form.name)}" required maxlength="100">
      <input name="pickup" placeholder="${escapeHtml(lang.pickup)}" aria-label="${escapeHtml(lang.pickup)}" required maxlength="160">
      <input name="destination" placeholder="${escapeHtml(lang.destination)}" aria-label="${escapeHtml(lang.destination)}" required maxlength="160">
      <div class="row">
        <label class="fieldlabel">${escapeHtml(lang.date)}<input name="date" type="date" min="${today}" required></label>
        <label class="fieldlabel">${escapeHtml(lang.time)}<input name="time" type="time" required></label>
      </div>
      <label class="fieldlabel">${escapeHtml(lang.passengers)}
        <input name="passengers" type="number" min="1" max="${maxPassengers}" value="2" required>
      </label>
      <input name="luggage" placeholder="${escapeHtml(form.luggage)}" aria-label="${escapeHtml(form.luggage)}" maxlength="120">
      <div id="flightField" class="hidden-field">
        <input name="flight" placeholder="${escapeHtml(form.flight)}" aria-label="${escapeHtml(form.flight)}" maxlength="30">
        <p class="formhint">${escapeHtml(form.flightHint)}</p>
      </div>
      <button class="cta">${escapeHtml(lang.bookWhats)}</button>
      <p id="bookingError" class="fineprint" style="color:#9a2929"></p>
      <p class="fineprint">${escapeHtml(lang.pending)}</p>
    </form>`);

  const formEl = need<HTMLFormElement>('#bf');
  const pickup = formEl.elements.namedItem('pickup') as HTMLInputElement;
  const destination = formEl.elements.namedItem('destination') as HTMLInputElement;
  const dateInput = formEl.elements.namedItem('date') as HTMLInputElement;
  const timeInput = formEl.elements.namedItem('time') as HTMLInputElement;
  const flightField = need('#flightField');
  const errorEl = need('#bookingError');

  const updateFlight = () => {
    flightField.classList.toggle('hidden-field', !AIRPORT_HINT.test(`${pickup.value} ${destination.value}`));
  };
  pickup.addEventListener('input', updateFlight);
  destination.addEventListener('input', updateFlight);

  const validateDateTime = (): boolean => {
    if (!dateInput.value || !timeInput.value) { errorEl.textContent = ''; return true; }
    const chosen = new Date(`${dateInput.value}T${timeInput.value}:00`);
    if (chosen.getTime() < Date.now() - 60_000) { errorEl.textContent = form.past; return false; }
    errorEl.textContent = '';
    return true;
  };
  dateInput.addEventListener('change', validateDateTime);
  timeInput.addEventListener('change', validateDateTime);

  formEl.onsubmit = (event) => {
    event.preventDefault();
    if (!validateDateTime()) return;
    if (!config.whatsapp) {
      errorEl.textContent = 'El contacto de reservas todavía no está configurado para este operador.';
      return;
    }

    const data = new FormData(formEl);
    const lines = [
      'Hola, quiero solicitar un transfer.',
      `Nombre: ${data.get('name')}`,
      `Recogida: ${data.get('pickup')}`,
      `Destino: ${data.get('destination')}`,
      `Fecha: ${data.get('date')}`,
      `Hora: ${data.get('time')}`,
      `Pasajeros: ${data.get('passengers')}`,
    ];
    if (String(data.get('luggage') ?? '').trim()) lines.push(`Equipaje: ${data.get('luggage')}`);
    if (String(data.get('flight') ?? '').trim()) lines.push(`Vuelo: ${data.get('flight')}`);
    lines.push(`Idioma del pasajero: ${lang.name}`);

    void metric('booking_whatsapp');
    window.open(
      `https://wa.me/${config.whatsapp}?text=${encodeURIComponent(lines.join('\n'))}`,
      '_blank', 'noopener',
    );
  };
}
